import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  dataVerifikasi: [],
  dataHistoryVerifikasi: [],
  dataLogFailedImport: [],
  keyword: {
    users: "",
    roles: "",
    verifikasi: "",
    log_failed_import: ""
  },
  selectType: [
    { value: "CHANGE_BRANCH", label: "Pindah Outlet" },
    { value: "USER_REGISTRATION", label: "Registrasi User" },
  ],
  loading: false,
  sortConfig: {
    key: "dibuatPada",
    direction: "DESC",
    historyVerifikasi: {
      key: "createdAt",
      direction: "DESC",
    }
  },
  listRole: [],
  listCabang: []
};

export const Users = createSlice({
  name: "users",
  initialState,
  reducers: {
    ChangeData: (state, action) => {
      state.data = action.payload;
    },
    ChangeDataVerifikasi: (state, action) => {
      state.dataVerifikasi = action.payload;
    },
    ChangeDataHistoryVerifikasi: (state, action) => {
      state.dataHistoryVerifikasi = action.payload;
    },
    ChangeDataLogFailedImport: (state, action) => {
      state.dataLogFailedImport = action.payload;
    },
    ChangeKeyword: (state, action) => {
      const { menu, value } = action.payload;
      state.keyword[menu] = value;
    },
    ChangeSelectType: (state, action) => {
      state.selectType = action.payload;
    },
    ChangeLoading: (state, action) => {
      state.loading = action.payload;
    },
    ChangeSortConfig: (state, action) => {
      state.sortConfig = action.payload;
    },
    ChangeListRole: (state, action) => {
      state.listRole = action.payload;
    },
    ChangeListCabang: (state, action) => {
      state.listCabang = action.payload;
    },
  },
});

export const {
  ChangeData,
  ChangeDataVerifikasi,
  ChangeDataHistoryVerifikasi,
  ChangeDataLogFailedImport,
  ChangeKeyword,
  ChangeSelectType,
  ChangeLoading,
  ChangeSortConfig,
  ChangeListRole,
  ChangeListCabang,
} = Users.actions;

export default Users.reducer;
